import React, { useState } from "react";
import { PROJECTS } from "../lib/siteData";
import { MapPin, Zap } from "lucide-react";
import CTABanner from "../components/CTABanner";
import SEO from "../components/SEO";

const TABS = ["All", "Residential", "Commercial", "Industrial"];

export default function ProjectsPage() {
  const [filter, setFilter] = useState("All");
  const filtered = filter === "All" ? PROJECTS : PROJECTS.filter((p) => p.category === filter);

  return (
    <div data-testid="projects-page">
      <SEO title="Projects" description="50+ MW of installed solar across India. Browse residential, commercial and industrial project case studies by CNGTPL Solar." />
      <section className="py-16 lg:py-20 bg-gradient-to-br from-slate-900 to-blue-900 text-white">
        <div className="container-narrow">
          <div className="badge-eco bg-blue-600/20 border-blue-600/40 text-blue-300 mb-3">Our Projects</div>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold tracking-tight mb-3">50+ MW powering India</h1>
          <p className="text-slate-300 max-w-2xl">Every project is custom-engineered, site-visited and commissioned by our in-house team. Browse by category.</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-narrow">
          <div className="flex flex-wrap gap-2 mb-8" data-testid="project-filters">
            {TABS.map((t) => (
              <button
                key={t}
                onClick={() => setFilter(t)}
                className={`px-5 py-2 rounded-full text-sm font-semibold transition ${
                  filter === t ? "bg-blue-600 text-white shadow-lg shadow-blue-600/20" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
                data-testid={`filter-${t.toLowerCase()}`}
              >
                {t}
              </button>
            ))}
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((p) => (
              <div key={p.id} className="group rounded-2xl overflow-hidden bg-white border border-slate-200 hover:shadow-xl hover:-translate-y-1 transition-all" data-testid={`project-card-${p.id}`}>
                <div className="aspect-[4/3] overflow-hidden bg-slate-100">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" loading="lazy" />
                </div>
                <div className="p-5">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs uppercase tracking-widest text-blue-700 font-bold">{p.category}</span>
                    <span className="flex items-center gap-1 text-xs text-slate-500"><Zap className="w-3 h-3" /> {p.capacity}</span>
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-slate-900 mb-1">{p.title}</h3>
                  <div className="flex items-center gap-1 text-sm text-slate-500"><MapPin className="w-3.5 h-3.5" /> {p.location}</div>
                </div>
              </div>
            ))}
          </div>

          {filtered.length === 0 && <div className="text-center py-12 text-slate-500">No projects in this category.</div>}
        </div>
      </section>

      <CTABanner title="Your project could be next" subtitle="Free site visit, custom design and transparent pricing. Reach out today." />
    </div>
  );
}
